module.exports = __webpack_public_path__ + "img/8-creates-a-real-and-natural-connection-with-colleagues.e0dedf3e.png";